import Commons from "oc-commons/Commons";
import Maths from "oc-commons/Maths";
import Textures from "oc-threejs/Textures";
import BaseType from "./BaseType";

export default class Bohrlochleiste extends BaseType(THREE.Mesh) {

    constructor() {
        super();
        this.geometry = new THREE.PlaneGeometry(1,1);
        this.material = new THREE.MeshStandardMaterial({
            transparent: true,
            opacity: 1,
            side: THREE.FrontSide,
        });
    }

    vsUpdate() {
        if (this.isVsChanged('cfgId')) {
            this.updateTexture();
        }
        if (this.isVsChanged('elementBox')
            || this.isVsChanged('cfgId')
            || this.isVsChanged('interieurSpecificBohrlochBounds')) {
            this.updateBox();
        }
    }

    updateTexture() {
        if (this.material.map) {
            this.material.map.dispose();
        }

        const cfg = this.vsData.cfg;
        const image = Bohrlochleiste.getBohrlochImage(cfg.abstand, cfg.durchmesser);
        const map = new THREE.Texture(image);
        map.anisotropy = Textures.getMaxAnisotropy();
        map.wrapS = THREE.RepeatWrapping;
        map.wrapT = THREE.RepeatWrapping;
        map.repeat.x = 1;
        map.repeat.y = 1;

        this.material.map = map;
        this.material.map.needsUpdate = true;
        this.material.needsUpdate = true;
    }

    updateBox() {
        const bounds = this.vsData.interieurSpecificBohrlochBounds;
        const center = bounds.getCenter();
        const size = bounds.getSize();
        const cfg = this.vsData.cfg;
        this.position.copy(size)
            .multiplyScalar(0.5)
            .sub(cfg.offset)
            .multiply(cfg.normal)
            .add(center);
        this.quaternion.copy(cfg.quaternion);
        this.scale.set(cfg.abstand, size.y, 1);
        const repeat = size.y / cfg.abstand;
        this.material.map.repeat.setY(repeat);
        this.material.map.needsUpdate = true;
        this.material.needsUpdate = true;
    }

    static getBohrlochImage = Commons.cache((abstand, durchmesser) => {
        const abstandInPx = Maths.ceilToNextPowerOf(abstand * 10);
        const canvas = document.createElement('canvas');
        $(canvas).attr('width', abstandInPx);
        $(canvas).attr('height', abstandInPx);
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = 'rgba(100,100,100,0)';
        ctx.fillRect(0,0,abstandInPx,abstandInPx);

        ctx.fillStyle = 'rgba(0,0,0,0.8)';
        ctx.beginPath();
        ctx.arc(abstandInPx / 2, abstandInPx / 2, durchmesser / 2 * abstandInPx / abstand, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.lineWidth = 2;
        ctx.strokeStyle = 'rgba(255,255,255,0.5)';
        ctx.stroke();
        return canvas;
    });

}
